/**
 * The store endpoints.
 *
 * Writes send exactly what `storeUpsertSchema` describes and read nothing back:
 * the caller invalidates the list instead. That costs one extra request and buys
 * immunity to whatever shape a create or update route chooses to answer with,
 * which is worth it for a resource edited a handful of times a year.
 */

import type { StoreUpsert } from '@pbtv/shared';
import { apiRequest, requestJson } from './api.js';
import { storeListSchema } from './schemas.js';
import type { StoreRecord } from './schemas.js';

export const STORES_QUERY_KEY = ['admin', 'stores'] as const;

export async function listStores(signal?: AbortSignal): Promise<StoreRecord[]> {
  return apiRequest(storeListSchema, '/admin/stores', { signal });
}

export async function createStore(input: StoreUpsert): Promise<void> {
  await requestJson('/admin/stores', { method: 'POST', body: input });
}

export async function updateStore(storeId: string, input: StoreUpsert): Promise<void> {
  await requestJson(`/admin/stores/${encodeURIComponent(storeId)}`, {
    method: 'PUT',
    body: input,
  });
}

export async function deleteStore(storeId: string): Promise<void> {
  await requestJson(`/admin/stores/${encodeURIComponent(storeId)}`, { method: 'DELETE' });
}
